import React, { useState } from 'react'
import { createContext } from 'react'
import { PRODUCTS } from '../products'
import Product from '../pages/shop/Product'

export const ShopContext = createContext(null)

// ADDING 
const getDefaultCart = () =>{
  let cart = {}
  for (let i = 1; i < PRODUCTS.length + 1; i++){
    cart[i] = 0;
  }
  return cart;
}

const ShopContextProvider = (props) => {
  const [cartItems, setCartItems] = useState(getDefaultCart())

  // ADD ITEMS FROM SHOP TO CART
  const addToCart = (itemId) =>{
    setCartItems((prev)=> ({...prev, [itemId]: prev[itemId] + 1}))
  }

  //REMOVING FROM CART FUNCTIONALITY
  const removeFromCart = (itemId) =>{
    setCartItems((prev)=> ({...prev, [itemId]: prev[itemId] - 1}))
  }

  //UPDATING THE COUNT IN THE CART when ADDING THE ITEMS IN THE SHOP
  const updateCartItemCount = (newAmount, itemId) =>{
    setCartItems((prev) => ({...prev, [itemId] : newAmount}))
  }

  // TO GET THE TOTAL CART AMOUNT
  const getTotalCartAmount = () =>{
    let totalAmount = 0;
    for(const item in cartItems){
      if (cartItems[item] > 0){
        let itemInfo = PRODUCTS.find((Product) => Product.id === Number(item))
        totalAmount += cartItems[item] * itemInfo.price
      }
    }
    return totalAmount
  }

  // ADDING THE ABOVE FUNCTIONS
  const contextValue = { 
    cartItems, 
    addToCart, 
    removeFromCart, 
    updateCartItemCount,
    getTotalCartAmount 
  }

  console.log(cartItems);
  return (
    <div>
      <ShopContext.Provider value={contextValue}>
        {props.children}
      </ShopContext.Provider>
    </div>
  )
}

export default ShopContextProvider
